


// import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
// import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import '../instance/InstanceForm.css';
// import ContactDetails from '../contact/ContactDetails';
// import LicenseList from '../license/LicenseList';
// import TenantView from './TenantView';
// import DocumentDetails from '../DocumentDetails';
// import { useAuth } from '../../context/AuthContext';
// import withPermission from '../../utils/withPermission';
// import SelectedContact from './../contact/SelectedContact';
// import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
// import { BiPencil } from "react-icons/bi";
// import { BsChevronLeft } from "react-icons/bs";
// import TenantModal from './TenantModal';
// const TenantDetail = () => {
//     const { id } = useParams(); // Get instance ID from the URL
//     const navigate = useNavigate();
//     const location = useLocation();

//     const [tenantDetails, setTenantDetails] = useState(null);
//     const queryParams = new URLSearchParams(location.search);
//     const initialTab = queryParams.get("activeTab") || "licenseList"; // Default tab
//     const [activeTab, setActiveTab] = useState("tenantInfo");
//     const WithLicensePermission = withPermission(({ children }) => children, ['license-list']);
//     const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
//     const WithDocPermission = withPermission(({ children }) => children, ['document-list']);
//     const [selectedTenant, setSelectedTenant] = useState(null);
//     const [showModal, setShowModal] = useState(false);
//     const [tenants, setTenants] = useState([]);
//     const [industries, setIndustries] = useState([]);

//     const didFetchRef = useRef(false); // Use ref to track whether the API has been called

//     // Function to fetch instance details
//     const fetchTenantDetails = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');

//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/tenants/${id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,

//                 },
//             });

//             setTenantDetails(response.data); // Set the fetched data to state
//         } catch (error) {
//             console.error('Error fetching instance details:', error);
//         }
//     };
//     const fetchIndustries = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let allIndustries = [];



//             const response = await axios.get(`${backendUrl}/api/industries`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             allIndustries = [...allIndustries, ...response.data.industry];


//             setIndustries(allIndustries);
//         } catch (error) {
//             console.error('Error fetching industries:', error);
//         }
//     };
//     const editTenant = async (tenantId, updatedData) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const updatedTenant = response.data?.Data;

//             if (updatedTenant) {

//                 updatedTenant.setup_name = updatedTenant.instance.setup_name;
//                 setTenantDetails((prevLead) => ({
//                     ...prevLead,
//                     ...updatedTenant, // Merge updated data
//                 }));
//                 setTenants((prevTenants) =>
//                     prevTenants.map((tenant) =>
//                         tenant.id === updatedTenant.id ? updatedTenant : tenant
//                     )
//                 );
//             } else {
//                 console.error('Update failed, no data returned.');
//             }

//             setShowModal(false);
//         } catch (error) {
//             if (error.response?.data?.errors) {
//                 return error.response?.data?.errors; // Return validation errors
//             } else {
//         setActiveTab(activeTabParam); // Set the active tab based on URL parameter
//     }, [location.search]);
//     // Handle back button click
//     const handleBackClick = () => {
//         navigate(-1);
//     };

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//         navigate(`${location.pathname}?activeTab=${tab}`); // Update URL with active tab
//     };

//     const getAccountStatusBadge = (status) => {
//         switch (status) {
//             case 'active':
//                 return <span className="badge badge-pill badge-soft-success font-size-11 text-success">Active</span>;
//             case 'deactivated':
//                 return <span className="badge badge-pill badge-soft-warning font-size-11 text-warning">Deactivated</span>;
//             case 'suspended':
//                 return <span className="badge badge-pill badge-soft-danger font-size-11 text-danger">Suspended</span>;
//             default:
//                 return <span className="badge badge-pill badge-soft-secondary font-size-12">Unknown</span>;
//         }
//     };
//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     {/* Page Title */}
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-sm-flex align-items-center justify-content-between">
//                                 <h4 className="mb-sm-0 font-size-15 d-flex align-items-center">
//                                     <BsChevronLeft
//                                         className='back-button1'
//                                         onClick={() => navigate(-1)}
//                                     />
//                                     <span>Tenant</span>
//                                 </h4>
//                                 <div className="page-title-right br-font">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><Link to={`/instance/details/${tenantDetails?.instance_id}`}>
//                                             {tenantDetails?.instance?.setup_name || "Instane Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item"><Link to={`/tenant/details/${id}?activeTab=tenantInfo`}>
//                                             {tenantDetails?.name || "Tenant Details"}
//                                         </Link></li>
//                                         <li className="breadcrumb-item active"><Link to="/tenants">Details</Link></li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="p-6 max-w-7xl mx-auto">
//                         <>
//                             <Card className="mb-4 shadow-lg rounded-3 p-2 border-0" style={{ background: "linear-gradient(135deg, #f8f9fa, #ffffff)" }}>
//                                 {/* Header Section with Name and Edit Icon */}
//                                 <div className="d-flex justify-content-between align-items-center">
//                                     <Card.Title className="fw-bold font-size-14 text-primary">{tenantDetails?.name}</Card.Title>
//                                     <BiPencil
//                                         className="text-primary hover-effect2 edit-pencil"

//                                         onClick={() => {
//                                             setSelectedTenant(tenantDetails); // Store organisation details
//                                             setShowModal(true); // Open modal
//                                         }} />
//                                 </div>
//                                 <Card.Body className="pt-3">
//                                     <div className="row">
//                                         {/* Left Section */}
//                                         <div className="col-md-6">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Tenant ID:</strong></span>
//                                                 <span className=" text-muted card-value">{tenantDetails?.tenant_id || '-'}</span>
//                                             </div>
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Status:</strong></span>
//                                                 <span className=" text-muted card-value">{getAccountStatusBadge(tenantDetails?.account_status) || '-'}</span>
//                                             </div>
//                                         </div>

//                                         {/* Right Section */}
//                                         <div className="col-md-4">
//                                             <div className="mb-3">
//                                                 <span className="text-muted d-block  card-label"><strong>Address:</strong></span>
//                                                 <span className="fw-semibold text-primary card-value">{tenantDetails?.address || ''}</span>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </Card.Body>
//                             </Card>
//                             {showModal && (
//                                 <TenantModal
//                                     showModal={showModal}
//                                     handleClose={() => setShowModal(false)}
//                                     tenantData={selectedTenant} // Pass data here
//                                     editTenant={editTenant}
//                                     tenants={tenants}
//                                     industries={industries}
//                                     fetchIndustries={fetchIndustries}
//                                     instanceId={selectedTenant?.instance_id}
//                                     tenantId={id}
//                                 />
//                             )}

//                         </>
//                         <div className="row">
//                             <div className="col-xl-12 col-lg-8">
//                                 <div className="card">
//                                     {/* Nav tabs */}
//                                     <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
//                                         <li className="nav-item">
//                                             <WithLicensePermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'licenseList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('licenseList')}
//                                                 role="tab"
//                                             >
//                                                 License
//                                             </a>
//                                             </WithLicensePermission>
//                                         </li>
//                                         <li className="nav-item">
//                                             <WithContactPermission>
//                                             <a
//                                                 className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('contactList')}
//                                                 role="tab"
//                                             >
//                                                 Contacts
//                                             </a>
//                                             </WithContactPermission>
//                                         </li>
//                                         <WithDocPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
//                                                 onClick={() => {
//                                                     setActiveTab('document');
//                                                 }}
//                                                 role="tab"
//                                             >
//                                                 Contract
//                                             </a>
//                                         </li>
//                                         </WithDocPermission>
//                                         <li className="nav-item">
//                                             <a
//                                                 className={`nav-link ${activeTab === 'tenantDetails' ? 'active' : ''}`}
//                                                 onClick={() => setActiveTab('tenantDetails')}
//                                                 role="tab"
//                                             >
//                                                 Tenant Details
//                                             </a>
//                                         </li>

//                                     </ul>
//                                     <div className="tab-content p-4">
//                                         {/* Contact List Tab */}
//                                         {activeTab === "contactList" && tenantDetails && (
//                                             <div className="tab-pane active" id="contact-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <SelectedContact tenantId={tenantDetails?.id}
//                                                         entityType="tenant"
//                                                         fetchTenantData={fetchTenantDetails}
//                                                         tenantData={tenantDetails}
//                                                         setTenantDetails={setTenantDetails}
//                                                     />
//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "licenseList" && tenantDetails && (
//                                             <div className="tab-pane active" id="license-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <LicenseList instanceId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "tenantDetails" && tenantDetails && (
//                                             <div className="tab-pane active" id="tenant-details" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <TenantView tenantData={tenantDetails} setTenantDetails={setTenantDetails} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                         {activeTab === "document" && tenantDetails && (
//                                             <div className="tab-pane active" id="document-list" role="tabpanel">
//                                                 <div className="p-3">
//                                                     <DocumentDetails instanceId={id} />

//                                                 </div>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         {/* <div className="row">
//                         <div className="col-12">
//                             <div className="email-leftbar card">
//                                 <div className="card-body">
//                                     <a  onClick={() => handleTabClick('tenantInfo')} className={`list-group-item list-group-item-action ${activeTab === 'tenantInfo' ? 'active-tab' : ''}`}>Tenant Info</a>
//                                     <WithLicensePermission><a  onClick={() => handleTabClick('license')} className={`list-group-item list-group-item-action ${activeTab === 'license' ? 'active-tab' : ''}`}>License</a></WithLicensePermission>
//                                     <WithContactPermission><a  onClick={() => handleTabClick('contacts')} className={`list-group-item list-group-item-action ${activeTab === 'contacts' ? 'active-tab' : ''}`}>Contacts</a></WithContactPermission>
//                                     <WithDocPermission><a  onClick={() => handleTabClick('documents')} className={`list-group-item list-group-item-action ${activeTab === 'documents' ? 'active-tab' : ''}`}>Contracts</a></WithDocPermission>
//                                     <div className="button-container">
//                                         <button onClick={handleBackClick} className="btn btn-secondary mb-4 back">Back</button>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="email-rightbar mb-3">
//                                 <div className="card">
//                                     <div className="card-body">
//                                         {activeTab === 'tenantInfo' && tenantDetails && (
//                                             <TenantView tenantData={tenantDetails}  setTenantDetails={setTenantDetails}/>
//                                         )}
//                                         {activeTab === 'license' && (
//                                             <LicenseList instanceId={id} />
//                                         )}
//                                         {activeTab === 'contacts' && tenantDetails && (
//                                             <SelectedContact tenantId={tenantDetails?.id}
//                                             entityType="tenant"
//                                             fetchTenantData={fetchTenantDetails}
//                                             tenantData={tenantDetails}
//                                             setTenantDetails={setTenantDetails}
//                                             />
//                                         )}
//                                         {activeTab === 'documents' && (
//                                            <DocumentDetails instanceId={id}/>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div> */}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default TenantDetail;


import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Offcanvas, Button, Form } from 'react-bootstrap';
import {
    FaBuilding,
    FaIdCard,
    FaMapMarkerAlt,
    FaKey,
    FaUsers,
    FaFileContract,
    FaInfoCircle,
    FaShieldAlt,
    FaGlobe
} from "react-icons/fa";
import { BiPencil } from "react-icons/bi";
import { BsX } from "react-icons/bs";
import ContactModal from '../contact/ContactModal';
import TenantView from './TenantView';
import DocumentDetails from '../DocumentDetails';
import LicenseList from '../license/LicenseList';
import SelectedContact from '../contact/SelectedContact';
import withPermission from '../../utils/withPermission';
import TenantModal from './TenantModal';
import LicenseDetails from '../license/LicenseDetails';
import LicenseModal from '../license/LicenseModal';

const LicenseListExtendOffcanvas = ({ show, onHide, selectedLicenseData, onSubmit }) => {
    const [extendType, setExtendType] = useState('days');
    const [extendValue, setExtendValue] = useState(1);
    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {
        if (show) {
            setExtendType('days');
            setExtendValue(1);
        }
    }, [show]);

    const handleInternalSubmit = async () => {
        setSubmitLoading(true);
        const result = await onSubmit({ extendType, extendValue });
        setSubmitLoading(false);
    };

    return (
        <Offcanvas show={show} onHide={onHide} placement="end" style={{ width: '540px' }}>
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title className="fw-bold">Extend License</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-4">
               
                <Form>
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold small form-label">Extend By</Form.Label>
                        <Form.Select 
                            value={extendType} 
                            onChange={(e) => setExtendType(e.target.value)}
                            className="form-select form-feild"
                        >
                            <option value="days">Days</option>
                            <option value="weeks">Weeks</option>
                            <option value="months">Months</option>
                            <option value="years">Years</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-4">
                        <Form.Label className="fw-semibold small form-label">Value</Form.Label>
                        <Form.Control 
                            type="number" 
                            min="1" 
                            value={extendValue} 
                            onChange={(e) => setExtendValue(parseInt(e.target.value) || '')}
                            className="form-control-lg form-feild"
                        />
                    </Form.Group>
                </Form>
            </Offcanvas.Body>
            <div className="p-3 bg-light border-top d-flex gap-2 justify-content-end">
                <Button variant="outline-secondary" onClick={onHide} disabled={submitLoading}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleInternalSubmit} disabled={submitLoading}>
                    {submitLoading ? 'Extending...' : 'Submit'}
                </Button>
            </div>
        </Offcanvas>
    );
};


const TenantDetail = ({ show, onHide, tenantId }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const initialTab = queryParams.get("activeTab") || "licenseList";

    const [tenantDetails, setTenantDetails] = useState(null);
    const [activeTab, setActiveTab] = useState(initialTab);
    const [showModal, setShowModal] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [isChildModalOpen, setIsChildModalOpen] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [closeOffcanvas, setCloseOffcanvas] = useState(false);
    const [showModalAfterClose, setShowModalAfterClose] = useState(false);
    const [modalTenantData, setModalTenantData] = useState(null);
    const [showLicenseDetail, setShowLicenseDetail] = useState(false);
    const [viewLicenseId, setViewLicenseId] = useState(null);
    const [showLicenseModal, setShowLicenseModal] = useState(false);
    const [showExtendModal, setShowExtendModal] = useState(false);
    const [selectedLicenseId, setSelectedLicenseId] = useState(null);
    const [selectedLicenseData, setSelectedLicenseData] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [isContactEdit, setIsContactEdit] = useState(false);
    const [contactFormData, setContactFormData] = useState({ name: '', email: '', phone: '', position: '' });
    const [contactErrors, setContactErrors] = useState({});
    const [domains, setDomains] = useState([]);

    const WithLicensePermission = withPermission(({ children }) => children, ['license-list']);
    const WithContactPermission = withPermission(({ children }) => children, ['contact-list']);
    const WithDocPermission = withPermission(({ children }) => children, ['document-list']);

    const didFetchRef = useRef(false);
    const contactRef = useRef();
    const contactSiblingRef = useRef();
    const documentRef = useRef();
    const documentSiblingRef = useRef();
    const [localShow, setLocalShow] = useState(show);

    // Sync with parent show prop
    useEffect(() => {
        setLocalShow(show);
    }, [show]);

    const fetchDomains = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/domain`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            setDomains(response.data.Data.data || response.data.Data || []);
        } catch (error) {
            console.error('Error fetching domains:', error);
        }
    };


    // Function to fetch tenant details
    const fetchTenantDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentId = tenantId || id;
            const response = await axios.get(`${backendUrl}/api/tenants/${currentId}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setTenantDetails(response.data?.tenant || response.data?.Data || response.data?.data || response.data);
        } catch (error) {
            console.error('Error fetching tenant details:', error);
        }
    };

    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader:true,
            });

            setIndustries(response.data.industry || []);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };

    const editTenant = async (tenantId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/tenants/${tenantId}`, updatedData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedTenant = response.data?.Data || response.data?.data || response.data;

            if (updatedTenant) {
                // Ensure the relationship setup_name is preserved if possible
                if (updatedTenant.instance && !updatedTenant.setup_name) {
                    updatedTenant.setup_name = updatedTenant.instance.setup_name;
                }
                
                setTenantDetails((prevTenant) => ({
                    ...prevTenant,
                    ...updatedTenant,
                }));
            }

            setShowModal(false);
            return {}; // Return empty object on success
        } catch (error) {
            console.error('Error updating tenant:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to update tenant' };
        }
    };

    const addLicense = async (newLicense) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const currentTenantId = tenantId || id;
            const response = await axios.post(`${backendUrl}/api/licenses`, newLicense, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    tenant_info_id: currentTenantId,
                },
            });

            // Trigger fetch to refresh the list 
            fetchTenantDetails();
            setShowLicenseModal(false);
            return {};
        } catch (error) {
            console.error('Error adding license:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to add license' };
        }
    };

    const editLicense = async (editId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const updateUrl = `${backendUrl}/api/licenses/${editId}?_method=PUT`;

            if (updatedData instanceof FormData) {
                // If it's FormData, let the browser handle Content-Type and boundaries
                await axios.post(updateUrl, updatedData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
            } else {
                await axios.post(updateUrl, updatedData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    params: {
                        tenant_info_id: tenantId || id,
                    },
                });
            }

            // Refresh view
            fetchTenantDetails();
            setShowLicenseModal(false);
            return {};
        } catch (error) {
            console.error('Error updating license:', error);
            if (error.response?.data?.errors) {
                return error.response.data.errors;
            }
            return { general: 'Failed to update license' };
        }
    };

  
        useEffect(() => {
            if (localShow && tenantId) {
                setTenantDetails(null); // Clear previous data
               fetchTenantDetails();
               fetchIndustries();
            }
        }, [localShow, tenantId]);

        useEffect(() => {
        setIsChildModalOpen(showLicenseDetail || showLicenseModal || showContactModal || showDocumentModal || showExtendModal);
    }, [showLicenseDetail, showLicenseModal, showContactModal, showDocumentModal, showExtendModal]);

    const handleSubmitExtend = async (data) => {
        if (selectedLicenseData) {
            const updatedData = {
                extension_type: data.extendType,
                extension_days: data.extendValue,
            };
    
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const response = await axios.post(`${backendUrl}/api/licenses/${selectedLicenseData.id}/extend`, updatedData,{
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                });
    
                // Update successfully, close and refresh
                fetchTenantDetails();
                setShowExtendModal(false);
                return { success: true };
            } catch (error) {
                console.error("Error extending license:", error);
                return { success: false, errors: error.response?.data?.errors };
            }
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const handleOffcanvasClose = () => {
        setTenantDetails(null);
        setActiveTab('licenseList');
        didFetchRef.current = false;
        onHide();
    };

    const getAccountStatusBadge = (status) => {
        switch (status) {
            case 'active':
                return <span className="badge bg-success">Active</span>;
            case 'deactivated':
                return <span className="badge bg-warning">Deactivated</span>;
            case 'suspended':
                return <span className="badge bg-danger">Suspended</span>;
            default:
                return <span className="badge bg-secondary">Unknown</span>;
        }
    };

    return (
        <>
        <Offcanvas
             show={localShow && !showModal && !isChildModalOpen}
            onHide={handleOffcanvasClose}
            placement="end"
            style={{ width: '1230px', zIndex: 1050 }}
            className="Tenant-offcanvas"
            unmountOnExit={false}
        >
            {/* Offcanvas Header */}
            <Offcanvas.Header className="border-bottom bg-white py-3">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center">
                        <div className="bg-primary rounded-circle p-2 me-3">
                            <FaBuilding className="text-white" size={18} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold text-dark">{tenantDetails?.name}</h5>
                            <small className="text-muted">Tenant ID: {tenantId || id}</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="outline-primary"
                            size="sm"
                              onClick={() => {
                                setSelectedTenant(tenantDetails);
                                setShowModal(true);
                            }}
                        >
                            <BiPencil className="me-1" />
                            Edit Tenant
                        </Button>

                        <Button
                            variant="light"
                            size="sm"
                            onClick={handleOffcanvasClose}
                            className="border-0"
                        >
                            <BsX size={20} />
                        </Button>
                    </div>
                </div>
            </Offcanvas.Header>

            {/* Offcanvas Body */}
            <Offcanvas.Body className="p-0">
                {/* Tenant Summary Card */}
                <div className="p-4 border-bottom bg-light">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaIdCard className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Tenant ID</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {tenantDetails?.tenant_id || 'Not assigned'}
                                    </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex align-items-center">
                                <div className="bg-white rounded-circle p-2 shadow-sm me-3">
                                    <FaShieldAlt className="text-primary" size={16} />
                                </div>
                                <div>
                                    <label className="text-muted small mb-1 d-block">Status</label>
                                    <h6 className="mb-0 fw-semibold text-dark">
                                        {getAccountStatusBadge(tenantDetails?.account_status)}
                                    </h6>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>

                {/* Navigation Tabs */}
                <div className="border-bottom bg-white">
                    <ul className="nav nav-tabs nav-tabs-custom nav-justified" role="tablist">
                        <WithLicensePermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'licenseList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('licenseList')}
                                    role="tab"
                                >
                                    <FaKey className="me-2" size={14} />
                                    License
                                </button>
                            </li>
                        </WithLicensePermission>

                        <WithContactPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'contactList' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('contactList')}
                                    role="tab"
                                >
                                    <FaUsers className="me-2" size={14} />
                                    Contacts
                                </button>
                            </li>
                        </WithContactPermission>

                        <WithDocPermission>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'document' ? 'active' : ''}`}
                                    onClick={() => handleTabClick('document')}
                                    role="tab"
                                >
                                    <FaFileContract className="me-2" size={14} />
                                    Contract
                                </button>
                            </li>
                        </WithDocPermission>

                        <li className="nav-item">
                            <button
                                className={`nav-link ${activeTab === 'tenantDetails' ? 'active' : ''}`}
                                onClick={() => handleTabClick('tenantDetails')}
                                role="tab"
                            >
                                <FaInfoCircle className="me-2" size={14} />
                                Tenant Details
                            </button>
                        </li>
                    </ul>
                </div>

                {/* Tab Content */}
                <div className="tab-content p-4 bg-white" style={{ minHeight: '500px', maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
                    {/* License List Tab */}
                    {activeTab === "licenseList" && tenantDetails && (
                        <div className="tab-pane active">
                             <LicenseList 
                                tenantId={tenantId || id} 
                                fetchTenantData={fetchTenantDetails}
                                showExtendModal={showExtendModal}
                                onShowExtendModal={(licenseId, data) => {
                                    setSelectedLicenseId(licenseId);
                                    setSelectedLicenseData(data);
                                    setShowExtendModal(true);
                                }}
                                onHideExtendModal={() => setShowExtendModal(false)}
                                onShowModal={(id, data) => {
                                    setSelectedLicenseId(id);
                                    setSelectedLicenseData(data);
                                    setShowLicenseModal(true);
                                }}
                                onViewDetails={(licenseId) => {
                                    setViewLicenseId(licenseId);
                                    setShowLicenseDetail(true);
                                }}
                             />
                        </div>
                    )}

                    {/* Contact List Tab */}
                    {activeTab === "contactList" && tenantDetails && (
                        <div className="tab-pane active">
                            <SelectedContact 
                                ref={contactRef}
                                tenantId={tenantId || id} 
                                entityType="tenant"
                                fetchTenantData={fetchTenantDetails}
                                tenantData={tenantDetails}
                                setTenantDetails={setTenantDetails}
                                showContactModal={showContactModal}
                                setShowContactModal={setShowContactModal}
                                onShowModal={(isEdit, data) => {
                                    setIsContactEdit(isEdit);
                                    if (data) setContactFormData(data);
                                    else setContactFormData({ name: '', email: '', phone: '', position: '' });
                                    setShowContactModal(true);
                                    if (contactSiblingRef.current) {
                                        contactSiblingRef.current.setIsEdit(isEdit);
                                        contactSiblingRef.current.setFormData(data || { name: '', email: '', phone: '', position: '' });
                                    }
                                }}
                             />
                        </div>
                    )}

                    {/* Document Tab */}
                    {activeTab === "document" && tenantDetails && (
                        <div className="tab-pane active">
                             <DocumentDetails 
                                ref={documentRef}
                                instanceId={tenantId || id} 
                                documentableType="tenant"
                                onModalStateChange={setShowDocumentModal}
                                onShowModal={(isEdit, data) => {
                                    if (documentSiblingRef.current) {
                                        documentSiblingRef.current.setIsEdit(isEdit);
                                        documentSiblingRef.current.setFormData(data);
                                        documentSiblingRef.current.setShowModal(true);
                                    }
                                    setShowDocumentModal(true);
                                }}
                             />
                        </div>
                    )}

                    {/* Tenant Details Tab */}
                    {activeTab === "tenantDetails" && (
                        <div className="tab-pane active">
                            {tenantDetails ? (
                                <TenantView
                                    tenantData={tenantDetails}
                                    setTenantDetails={setTenantDetails}
                                />
                            ) : (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading tenant details...</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </Offcanvas.Body>

        </Offcanvas>

        {/* License Details Sub-Offcanvas */}
        <LicenseDetails
            show={showLicenseDetail}
            onHide={() => { 
                setShowLicenseDetail(false); 
                setTimeout(() => setViewLicenseId(null), 350); 
            }}
            licenseId={viewLicenseId}
        />
        {/* Document Add/Edit Modal (as Sibling) */}
        <DocumentDetails 
            ref={documentSiblingRef}
            instanceId={tenantId || id} 
            hideList={true} 
            documentableType="tenant"
            onModalStateChange={setShowDocumentModal}
        />
        {/* Contact Add/Edit Modal */}
        {showContactModal && (
            <ContactModal
                showModal={showContactModal}
                handleClose={() => setShowContactModal(false)}
                isEdit={isContactEdit}
                formData={contactFormData}
                handleInputChange={(e) => {
                    const { name, value } = e.target;
                    setContactFormData(prev => ({ ...prev, [name]: value }));
                    setContactErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[name];
                        return newErrors;
                    });
                    if (contactSiblingRef.current) contactSiblingRef.current.handleManualInputChange(e);
                }}
                errors={contactErrors}
                handleSubmit={async () => {
                   if (contactSiblingRef.current) {
                        try {
                            const result = await contactSiblingRef.current.handleSubmit(contactFormData);
                            if (result && !result.success) {
                                setContactErrors(result.errors || {});
                            }
                        } catch (err) {
                            console.error("Save failure:", err);
                        }
                    }
                }}
            />
        )}
        {/* Headless Contact Implementation for Sibling Modal */}
        <SelectedContact 
            ref={contactSiblingRef}
            tenantId={tenantId || id}
            entityType="tenant"
            hideList={true}
            setTenantDetails={setTenantDetails}
            showContactModal={showContactModal}
            setShowContactModal={setShowContactModal}
        />
        {/* License Add/Edit Modal */}
        {showLicenseModal && (
            <LicenseModal
                showModal={showLicenseModal}
                handleClose={() => {
                    setShowLicenseModal(false);
                    setSelectedLicenseId(null);
                    setSelectedLicenseData(null);
                }}
                selectedLicenseId={selectedLicenseId}
                selectedLicenseData={selectedLicenseData}
                addLicense={addLicense}
                editLicense={editLicense}
                tenantId={tenantId || id}
            />
        )}
        {/* Extend License Offcanvas (as Sibling) */}
        <LicenseListExtendOffcanvas 
            show={showExtendModal}
            onHide={() => setShowExtendModal(false)}
            selectedLicenseData={selectedLicenseData}
            onSubmit={handleSubmitExtend}
        />
        {/* Tenant Modal */}
        {showModal && (
            <TenantModal
                showModal={showModal}
                handleClose={() => setShowModal(false)}
                tenantData={selectedTenant}
                editTenant={editTenant}
                industries={industries}
                fetchIndustries={fetchIndustries}
                instanceId={selectedTenant?.instance_id}
                tenantId={tenantId || id}
                domains={domains}
                fetchDomains={fetchDomains}
            />
        )}
        </>
    );
};




export default TenantDetail;
